import Papa from "papaparse";

export default function (response) {
  let translations = {};
  Papa.parse(response.data, {
    complete: (results) => {
      const sheetsArray = results.data;
      // console.log("sheetsArray", sheetsArray);
      sheetsArray[0].forEach((locale) => {
        if (locale !== "key") {
          translations[locale] = {};  // simple create an empty objects for each locale
        }
      });
      sheetsArray.forEach((translatesArray, translatesArrayIndex) => { // vertical forEach
        if (translatesArrayIndex) { // not 0 (the first key line)
          const key = translatesArray[0]; // key, for ex. login.email
          translatesArray.forEach((translateValue, translateValueIndex) => { // horizontal forEach
            if (translateValueIndex) { // skip first key
              const locale = sheetsArray[0][translateValueIndex]; // get first line and locale index
              translations[locale][key] = translateValue
            }
          });
        }
      });
    }
  });
  return translations
}
